import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import CustomDialog from './CustomDialog';
import VoucherWithActions from '../../misc/VoucherWithActions';

const VoucherCodeDialog = ({ open, onClose, voucher }) => {
  return (
    <CustomDialog open={open}>
      <div className="notification-container">
        <DialogContent>
          <div className="notification-body">
            <VoucherWithActions voucher={voucher} />
          </div>
        </DialogContent>
        <DialogActions>
          <div className="notification-action">
            <button className="accept" onClick={onClose}>
              <FormattedMessageWrappedInSpan
                id="searchInstructionsDialog.acceptButton"
                defaultMessage="OK"
              />
            </button>
          </div>
        </DialogActions>
      </div>
    </CustomDialog>
  );
};

VoucherCodeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  voucher: PropTypes.object,
};

export default VoucherCodeDialog;
